import { AlphaQBoxIcon } from './AlphaQBoxIcon';

/**
 * author: GreenTurtwig
 * id 4B916C98-B981-4822-90D2-3EADCAE01FA3
 * name alpha-q-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-q-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetQBoxIcon = AlphaQBoxIcon;
export default AlphabetQBoxIcon